export const LocalStorageKeys = {
  AuthToken: "auth_token",
  Groups: "groups",
};
